module.exports = __webpack_public_path__ + "img/3CX-badge-background.dc1da1c3.jpeg";